var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-step-wrapper",class:{
    'divStepActivated': this.selected,
    'divStepPassed': this.passed,
    'divStepJumpable': this.jumpable,
  },on:{"click":_vm.onStepClicked}},[_c('div',{staticClass:"divStep"},[_vm._v("\n    "+_vm._s(_vm.stepNumber)+"\n  ")]),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))])])}
var staticRenderFns = []

export { render, staticRenderFns }